import { useTranslation } from "lib/i18n/translation"
import { useState } from "react"
import image, { DIRECTOR_AVATAR, DIRECTOR_TOP } from "lacinetek-common/src/images"
const BIO_DISPLAY = "bio"
const FILMO_DISPLAY = "filmo"
import fullname from "lib/tools/name"
import { getFilm } from "lib/film-fetcher"
import { useCountry } from "lib/country"
import { useLanguages } from "lib/languages"
import useHandleLinkFromContent from "lib/content/link"
import Image from "components/common/image"

export default ({ list, filmo, director, loading }) => {

	const [descriptionDisplay, setDescriptionDisplay] = useState(BIO_DISPLAY)
	const { current } = useLanguages()
	const { country, countrySlug } = useCountry()
	const handleLinkFromContent = useHandleLinkFromContent({
		slugBuilder: (slug, countrySlug) => {
			return getFilm(slug, current, country)
				.then(product => {
					if (!product) {
						return []
					}

					return [
						`/[lang]/film/[id]?lang=${countrySlug}`,
						`/${countrySlug}/film/${product.linkRewrite}`
					]
				})
		}
	})

	const { c } = useTranslation("common")

	return (
		<section className="black focus has-splitted">
			<div className="splitted invert">
				<figure className="avatar">
					<picture>
						<Image src={image(director, DIRECTOR_AVATAR, DIRECTOR_TOP)} alt={director.name} />
					</picture>
				</figure>
				<div className="content">
					<h1 className={`${loading ? "skeleton" : ""} title-alt`}>{fullname(list)}</h1>
					<nav data-tabs="#tabs-director" className="nav-tabs">
						<a href="#" onClick={e => { e.preventDefault(); setDescriptionDisplay(BIO_DISPLAY) }} rel="nofollow noopener" title="" className={`${descriptionDisplay == BIO_DISPLAY ? "active" : ""} ${loading ? "skeleton" : ""}`}><span>{c("biography")}</span></a>
						<a href="#" onClick={e => { e.preventDefault(); setDescriptionDisplay(FILMO_DISPLAY) }} rel="nofollow noopener" title="" className={`${descriptionDisplay == FILMO_DISPLAY ? "active" : ""} ${loading ? "skeleton" : ""}`}><span>{c("filmography")}</span></a>
					</nav>
					<ul id="tabs-director" className="tabs">
						<li className={`tab ${descriptionDisplay == BIO_DISPLAY ? "active" : ""} ${loading ? "skeleton" : ""}`} dangerouslySetInnerHTML={{ __html: director.description }} onClick={handleLinkFromContent} />
						<li className={`tab ${descriptionDisplay == FILMO_DISPLAY ? "active" : ""} ${loading ? "skeleton" : ""}`}>
							<div className="description director-filmo" onClick={handleLinkFromContent} dangerouslySetInnerHTML={{ __html: filmo.replace(/lacinetek.codekraft.fr/g, `www.lacinetek.com/${countrySlug}`) }} />
						</li>
					</ul>
				</div>
			</div>
		</section>
	)
}
